export default "__VITE_ASSET__7MUvW0cC__"